import { twMerge } from 'tailwind-merge'
import type { AskUserCardTheme } from './theme'

/** The borderless letter marker leading an option row. */
export function OptionBadge({
  letter,
  selected,
  theme,
}: {
  letter: string
  selected: boolean
  theme: AskUserCardTheme
}) {
  return (
    <span
      aria-hidden="true"
      className={twMerge(
        'relative mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full text-center',
        'transition-colors duration-150 ease-out',
        selected ? theme.accentDot : 'bg-foreground/[8%]',
      )}
    >
      <span
        className={twMerge(
          'flex h-full items-center justify-center text-center text-[9px] font-medium leading-none transition-colors duration-150 ease-out',
          selected ? 'text-black' : 'text-foreground-secondary',
        )}
      >
        {letter}
      </span>
    </span>
  )
}
